import {
    GESTION_OPERATIVA_ADD_PAYMENT_BEGIN,
    GESTION_OPERATIVA_ADD_PAYMENT_SUCCESS,
    GESTION_OPERATIVA_ADD_PAYMENT_ERROR
} from '../constants'
import { BFFAgent } from '../../../../common/BFFAgent'

export function addPayments(clientAndAdviserData) {
    return async dispatch => {
        dispatch({
            type: GESTION_OPERATIVA_ADD_PAYMENT_BEGIN
        })
        try {
            const response = await BFFAgent.Payments.addPayments(clientAndAdviserData)

            dispatch({
                type: GESTION_OPERATIVA_ADD_PAYMENT_SUCCESS,
                data: { urlAddPayment: response }
            })
        } catch (error) {
            dispatch({
                type: GESTION_OPERATIVA_ADD_PAYMENT_ERROR
            })
        }
    }
}